<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary secondary--text" style="word-break: normal">
                        CONFIGURAR IDENTIDAD DIDIT
                    </v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="getData">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
                <v-card>
                    <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
                    <v-form ref="form" v-model="valid" @submit.prevent="submit" lazy-validation>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-switch
                                        v-model="form.enabled"
                                        label="Activar Didit"
                                        color="primary"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.workflow_id"
                                        label="Workflow ID"
                                        prepend-icon="mdi-source-branch"
                                        :rules="[rules.req('workflow_id')]"
                                        :error-messages="errors.workflow_id"
                                        :disabled="loading"
                                        @input="clearErrors('workflow_id')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select
                                        v-model="form.callback_method"
                                        :items="callbackMethods"
                                        label="Callback Method"
                                        item-text="text"
                                        item-value="value"
                                        prepend-icon="mdi-call-merge"
                                        :rules="[rules.required('callback_method')]"
                                        :error-messages="errors.callback_method"
                                        :disabled="loading"
                                        @change="clearErrors('callback_method')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.api_key"
                                        :label="settings.api_key_configured ? 'API Key configurada' : 'API Key'"
                                        prepend-icon="mdi-key"
                                        :append-icon="showApiKey ? 'mdi-eye-off' : 'mdi-eye'"
                                        :type="showApiKey ? 'text' : 'password'"
                                        :placeholder="settings.api_key_configured ? 'Dejar vacio para conservar' : ''"
                                        :disabled="loading"
                                        :error-messages="errors.api_key"
                                        @click:append="showApiKey = !showApiKey"
                                        @input="clearErrors('api_key')"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="form.webhook_secret"
                                        :label="settings.webhook_secret_configured ? 'Webhook Secret configurado' : 'Webhook Secret'"
                                        prepend-icon="mdi-shield-key"
                                        :append-icon="showWebhookSecret ? 'mdi-eye-off' : 'mdi-eye'"
                                        :type="showWebhookSecret ? 'text' : 'password'"
                                        :placeholder="settings.webhook_secret_configured ? 'Dejar vacio para conservar' : ''"
                                        :disabled="loading"
                                        :error-messages="errors.webhook_secret"
                                        @click:append="showWebhookSecret = !showWebhookSecret"
                                        @input="clearErrors('webhook_secret')"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="form.language"
                                        label="Idioma"
                                        prepend-icon="mdi-translate"
                                        :rules="[rules.required('language')]"
                                        :error-messages="errors.language"
                                        :disabled="loading"
                                        @input="clearErrors('language')"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-switch
                                        v-model="form.auto_update_status"
                                        label="Actualizar estado del cliente"
                                        color="primary"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select
                                        v-model="form.declined_status"
                                        :items="declinedStatuses"
                                        label="Si Didit rechaza"
                                        item-text="text"
                                        item-value="value"
                                        prepend-icon="mdi-account-alert"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :value="settings.callback_url"
                                        label="Callback URL"
                                        readonly
                                        prepend-icon="mdi-link"
                                        append-icon="mdi-content-copy"
                                        @click:append="copy(settings.callback_url)"/>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :value="settings.webhook_url"
                                        label="Webhook URL"
                                        readonly
                                        prepend-icon="mdi-webhook"
                                        append-icon="mdi-content-copy"
                                        @click:append="copy(settings.webhook_url)"/>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn type="submit" color="success" :loading="loading" :disabled="loading || !valid">
                                <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import Form from "../../../helpers/form";

export default {
    name: "configIdentity",
    mixins: [ Form ],
    props: ['user'],
    data: () => ({
        loading: true,
        valid: true,
        showApiKey: false,
        showWebhookSecret: false,
        settings: {
            api_key_configured: false,
            webhook_secret_configured: false,
            callback_url: '',
            webhook_url: ''
        },
        form: {
            enabled: false,
            workflow_id: '',
            api_key: '',
            webhook_secret: '',
            callback_method: 'both',
            language: 'es',
            auto_update_status: true,
            declined_status: 101
        },
        callbackMethods: [
            { text: 'Ambos', value: 'both' },
            { text: 'Iniciador', value: 'initiator' },
            { text: 'Completador', value: 'completer' }
        ],
        declinedStatuses: [
            { text: 'Sin verificar', value: 101 },
            { text: 'Bloqueado', value: 104 }
        ]
    }),
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/settings/identity/didit').then(res => {
                this.applySettings(res.data.settings || {});
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar Didit.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        applySettings(settings) {
            this.settings = settings;
            this.form.enabled = !!settings.enabled;
            this.form.workflow_id = settings.workflow_id || '';
            this.form.api_key = '';
            this.form.webhook_secret = '';
            this.form.callback_method = settings.callback_method || 'both';
            this.form.language = settings.language || 'es';
            this.form.auto_update_status = settings.auto_update_status !== false;
            this.form.declined_status = Number(settings.declined_status || 101);
        },
        submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;
            axios.post('/api/settings/identity/didit', this.form).then(res => {
                this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                this.applySettings(res.data.settings || {});
            }).catch(err => {
                this.handleErrors(err.response && err.response.data ? err.response.data.errors : {});
                this.$toast.error(this.errorMessage(err, 'No fue posible guardar Didit.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        copy(value) {
            if (!value) return;
            navigator.clipboard.writeText(value).then(() => {
                this.$toast.success('URL copiada.', {icon: 'mdi-content-copy'});
            });
        },
        errorMessage(err, fallback) {
            if (err.response && err.response.data && err.response.data.status) {
                return err.response.data.status;
            }

            return fallback;
        }
    }
}
</script>

<style scoped>

</style>
